import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from 'rxjs';
import { SearchResult } from "../data/search-result";

import { v4 as uuidv4 } from 'uuid';
//import { Project } from "../data/Project";

@Injectable()
export class MockHttpInterceptor implements HttpInterceptor {


//  private projects: Project[] = [];

  constructor() {
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // console.log("----------------------------");
    // console.log("HTTPリクエスト:", request);
    // console.log("クエリパラメータ:");
    // request.params.keys().forEach(key => console.log(" " + key + ": " + request.params.getAll(key)?.join(', ')));


    // if (request.url.endsWith('/v1/projects')) {

    //   const cursor = request.params.get("cursor");
    //   const limit = request.params.has("limit") ? Number.parseInt(request.params.get("limit")!) : 20;
    //   const startIndex = cursor ? parseInt(cursor) : 0;
    //   const endIndex = Math.min(startIndex + limit, this.projects.length);
    //   const data = this.projects.slice(startIndex, endIndex);
    //   const hasNext = endIndex < this.projects.length;
    //   const nextCursor = hasNext ? endIndex.toString() : "";
    //   const hasPrev = startIndex > 0;
    //   const prevCursor = hasPrev ? Math.max(0, startIndex - limit).toString() : "";

    //   const result: SearchResult<Project> = {
    //     data: data,
    //     size: data.length,
    //     cursor: cursor || "0",
    //     limit: limit,
    //     hasNext: hasNext,
    //     nextCursor: nextCursor,
    //     hasPrev: hasPrev,
    //     prevCursor: prevCursor
    //   };
    //   let response = new HttpResponse({ status: 200, body: result });
    //   console.log("HTTPレスポンス:", response);
    //   console.log("レスポンスデータ:", result);
    //   return of(response);

    // }

    // if (/\/v1\/projects\/[^\/]+$/.test(request.url)) {
    //   let response = new HttpResponse({ status: 200, body: this.getRandomProject() });
    //   return of(response);
    // }
console.log("mock request", request);
    return next.handle(request);
  }
}